import styled from "styled-components";
import { mobile as s } from "../../../../../ui/_themes/constants";
import { AutoplaySettingButton } from "../../../../../ui/AutoplaySettingButton";

export const Setting = styled(AutoplaySettingButton)`
  flex: 0 0 auto;
  display: block;
  margin-bottom: 0.9em;
  border-width: 0.1em;
  line-height: 2.4em;
  min-width: 45%;

  span:first-child {
    font-size: ${s.fontSize.xl};
  }
`;
